import React, { useContext, useState, useEffect } from 'react';
import { DashContext } from '../../contexts/dashProvider';
import Charts from './chartsApex';
import Loader from '../Loader/load';


const Dashboard = () => {
  const { dashStatus, loading } = useContext(DashContext);
  const [clientes, setClientes] = useState(null);
  const [anexos, setAnexos] = useState(null);
  const [patrimonios, setPatrimonios] = useState(null);
  const [fornecedores, setFornecedores] = useState(null);

  useEffect(() => {
    if (!clientes && !anexos && !patrimonios && !fornecedores && dashStatus) {
      setClientes(dashStatus.clientes);
      setAnexos(dashStatus.anexos);
      setPatrimonios(dashStatus.patrimonios);
      setFornecedores(dashStatus.fornecedores);
    }
  }, [dashStatus, clientes, anexos, patrimonios, fornecedores]);

  return (
    <div className='min-h-full p-6'>
      {loading ? (
        <div className="flex items-center justify-center min-h-96">
          <Loader size="large" />
        </div>
      ) : (
        <div className='space-y-8'>
          <div className="flex items-center justify-between">
            <h1 className="text-4xl font-bold text-vox-blue-900 dark:text-white">Dashboard</h1>
            <div className="text-sm text-gray-600 dark:text-gray-400">
              Visão geral do sistema
            </div>
          </div>

          <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6'>
            <div className="card-vox">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-xl font-semibold text-vox-blue-900 dark:text-white">Patrimônios</h3>
                <div className="w-3 h-3 bg-vox-blue-600 rounded-full"></div>
              </div>
              <div className="flex items-center justify-center min-h-64">
                {patrimonios?.totalPatrimonios > 0 ? (
                  <Charts type='pie' data={patrimonios} total={patrimonios?.totalPatrimonios + patrimonios?.totalPatrimoniosnfs} id='patrimonios-chart'/>
                ) : (
                  <p className="text-gray-500 dark:text-gray-400 text-center">Nenhum patrimônio cadastrado</p>
                )}
              </div>
            </div>

            <div className="card-vox">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-xl font-semibold text-vox-blue-900 dark:text-white">Anexos</h3>
                <div className="w-3 h-3 bg-vox-green-600 rounded-full"></div>
              </div>
              <div className="flex items-center justify-center min-h-64">
                {anexos?.totalAnexos > 0 ? (
                  <Charts type='pie' data={anexos} total={anexos.totalAnexos} id='anexos-chart'/>
                ) : (
                  <p className="text-gray-500 dark:text-gray-400 text-center">Nenhum anexo cadastrado</p>
                )}
              </div>
            </div>

            <div className="card-vox">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-xl font-semibold text-vox-blue-900 dark:text-white">Fornecedores</h3>
                <div className="w-3 h-3 bg-yellow-600 rounded-full"></div>
              </div>
              <div className="flex items-center justify-center min-h-64">
                {fornecedores?.totalFornecedores > 0 ? (
                  <Charts type='pie' data={fornecedores} total={fornecedores?.totalFornecedores} id='fornecedores-chart'/>
                ) : (
                  <p className="text-gray-500 dark:text-gray-400 text-center">Nenhum fornecedor cadastrado</p>
                )}
              </div>
            </div>

            <div className="card-vox">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-xl font-semibold text-vox-blue-900 dark:text-white">Clientes</h3>
                <div className="w-3 h-3 bg-green-600 rounded-full"></div>
              </div>
              <div className="flex items-center justify-center min-h-64">
                {clientes?.totalClientes > 0 ? (
                  <Charts type='pie' data={clientes} total={clientes?.totalClientes} id='clientes-chart' />
                ) : (
                  <p className="text-gray-500 dark:text-gray-400 text-center">Nenhum cliente cadastrado</p>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
